module.exports = __webpack_public_path__ + "img/waving-hand.4f87c84c.png";